import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=2725c289&scoped=true&"
import script from "./userCenter.vue?vue&type=script&lang=js&"
export * from "./userCenter.vue?vue&type=script&lang=js&"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=2725c289&scoped=true&lang=css&"
import style1 from "./userCenter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2725c289",
  null
  
)

export default component.exports